export default [
    {
        name: '__checkbox',
        titleClass: 'center aligned',
        dataClass: 'center aligned'
    },
    {
        name: '__slot:links_source_name',
        sortField: 'source_name',
        type: 'string',
        defaultSearch: true,
        useInFilter: true,
    },
    {
        name: '__slot:links_source_url',
        sortField: 'source_url',
        type: 'string',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'source_dr',
        sortField: 'source_dr',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'source_title',
        sortField: 'source_title',
        type: 'string',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'source_ip',
        sortField: 'source_ip',
        type: 'ip',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:links_url',
        sortField: 'url',
        type: 'string',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:links_anchor',
        sortField: 'anchor',
        type: 'string',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'link_type',
        sortField: 'link_type',
        type: 'link_type',
        callback: 'linkType',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'rel_type',
        sortField: 'rel_type',
        type: 'rel_type',
        defaultValue: () => [],
        callback: 'linkRelType',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'created_at',
        sortField: 'created_at',
        type: 'dateRange',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'updated_at',
        sortField: 'updated_at',
        type: 'dateRange',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'status',
        sortField: 'status',
        callback: 'linkStatus',
        type: 'link_status',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        // Только в фильтре: путь страницы сайта, на которую ведут ссылки (сюда ведут ссылки из пакетного анализа
        // по ссылкам в режиме URL). Корень — /
        name: 'path',
        type: 'string',
        visible: false,
        defaultSearch: false,
        useInFilter: true,
    }
]
